import { useQuery } from '@tanstack/react-query';
import { getPageBySlug, getPosts, getPostBySlug } from '../api/client';
import type { Page, Post } from '../api/client';

// Query key factory for cache invalidation and prefetching
export const wordpressKeys = {
  all: ['wordpress'] as const,
  pages: () => [...wordpressKeys.all, 'page'] as const,
  page: (slug: string) => [...wordpressKeys.pages(), slug] as const,
  posts: () => [...wordpressKeys.all, 'posts'] as const,
  postList: (perPage: number) => [...wordpressKeys.posts(), { perPage }] as const,
  post: (slug: string) => [...wordpressKeys.posts(), slug] as const,
};

export const useWordPressPage = (slug: string, options?: { enabled?: boolean }) =>
  useQuery<Page>({
    queryKey: wordpressKeys.page(slug),
    queryFn: () => getPageBySlug(slug),
    enabled: (options?.enabled ?? true) && !!slug,
  });

export const useWordPressPosts = (perPage = 10) =>
  useQuery<Post[]>({
    queryKey: wordpressKeys.postList(perPage),
    queryFn: () => getPosts(1, perPage),
  });

export const useWordPressPost = (slug: string) =>
  useQuery<Post>({
    queryKey: wordpressKeys.post(slug),
    queryFn: () => getPostBySlug(slug),
    enabled: !!slug,
  });
